import React from 'react';
import BuyConfirmation from './BuyConfirmation';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import BuyCryptoForm from './BuyCryptoForm';
import PropTypes from 'prop-types';

const BuyCryptoModal = ({
    formData,
    setFormData,
    fieldError,
    setFieldError,
    exchangeRate,
    loadingRate,
    quotationData,
    isLoading,
    isConfirmModal,
    isOpen,
    onClose,
    onBack,
    handleConfirmationModal,
    onClickCall,
    handleAmountChange,
    handleCurrencyChange,
    balancesCurrencies,
    updatedUnfreeze,
}) => {
    const hasFieldErrors = Object.values(fieldError || {}).some(error => error);
    const hasEmptyRequiredFields =
        !formData?.fiatAmount ||
        !formData?.cryptoAmount ||
        !formData?.fiatCurrency ||
        !formData?.cryptoID;

    return (
        <TransactionCommonModal
            open={isOpen}
            onClose={onClose}
            onBack={onBack}
            heading={!isConfirmModal ? 'BUY' : 'BUY CONFIRMATION'}
            bottomButtonText={!isConfirmModal ? 'CONTINUE' : isLoading ? 'Processing' : 'BUY NOW'}
            onBottomButtonClick={!isConfirmModal ? handleConfirmationModal : onClickCall}
            showBackButton={isConfirmModal}
            showCloseIcon={true}
            loading={isLoading}
            disabled={
                // isLoading ||
                (!isConfirmModal && (hasFieldErrors || hasEmptyRequiredFields)) ||
                (isConfirmModal &&
                    (!quotationData ||
                        Object.keys(quotationData).length === 0 ||
                        quotationData.error))
            }>
            {!isConfirmModal ? (
                <BuyCryptoForm
                    formData={formData}
                    setFormData={setFormData}
                    fieldError={fieldError}
                    setFieldError={setFieldError}
                    handleAmountChange={handleAmountChange}
                    handleCurrencyChange={handleCurrencyChange}
                    exchangeRate={exchangeRate}
                    loadingRate={loadingRate}
                    balancesCurrencies={balancesCurrencies}
                    updatedUnfreeze={updatedUnfreeze}
                />
            ) : (
                <BuyConfirmation
                    formData={{
                        fiatCurrency: formData?.fiatCurrency,
                        cryptoID: formData?.cryptoID,
                        fiatAmount: formData?.fiatAmount,
                        cryptoAmount: formData?.cryptoAmount,
                    }}
                    quotationData={quotationData}
                    loadingRate={loadingRate}
                />
            )}
        </TransactionCommonModal>
    );
};

BuyCryptoModal.propTypes = {
    formData: PropTypes.shape({
        fiatCurrency: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        cryptoID: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        fiatAmount: PropTypes.string,
        cryptoAmount: PropTypes.string,
    }),
    fieldError: PropTypes.shape({
        fiatCurrency: PropTypes.string,
        cryptoID: PropTypes.string,
        fiatAmount: PropTypes.string,
        cryptoAmount: PropTypes.string,
    }),
    exchangeRate: PropTypes.string,
    loadingRate: PropTypes.bool,
    fee: PropTypes.number,
    quotationData: PropTypes.object,
    isLoading: PropTypes.bool,
    isConfirmModal: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleConfirmationModal: PropTypes.func.isRequired,
    onClickCall: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    balancesCurrencies: PropTypes.array,
    updatedUnfreeze: PropTypes.array,
};

BuyCryptoForm.defaultProps = {
    formData: {},
    fieldError: {},
    loadingRate: false,
    balancesCurrencies: [],
    updatedUnfreeze: [],
};

export default BuyCryptoModal;
